/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_MinutesInputs */

const en_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const fr_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const de_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

const it_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuti`)
};

const ru_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протокол`)
};

const es_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

const zh_cn2_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

const ja_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const hi_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिनट`)
};

const pt_pt2_usage_metric_minutes = /** @type {(inputs: Usage_Metric_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

/**
* | output |
* | --- |
* | "Minutes" |
*
* @param {Usage_Metric_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_minutes = /** @type {((inputs?: Usage_Metric_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_metric_minutes(inputs)
	if (locale === "de") return de_usage_metric_minutes(inputs)
	if (locale === "it") return it_usage_metric_minutes(inputs)
	if (locale === "ru") return ru_usage_metric_minutes(inputs)
	if (locale === "es") return es_usage_metric_minutes(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_metric_minutes(inputs)
	if (locale === "ja") return ja_usage_metric_minutes(inputs)
	if (locale === "hi") return hi_usage_metric_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_metric_minutes(inputs)
	return en_usage_metric_minutes(inputs)
});